import { createStyles, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer";

const useStyles = createStyles((theme) => ({
  bar: {
    backgroundColor: theme.colors.orange[1],
    borderBottom: `1px solid ${theme.colors.orange[2]}`,
    width: "100%",
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 36,
    padding: `${theme.spacing.xs}px 0`,
    textAlign: "center",
  },
  text: {
    fontSize: theme.fontSizes.xs,
    color: theme.colors.gray[8],
    lineHeight: 1.4,
    letterSpacing: "0.04em",
  },
  link: {
    color: theme.colors.orange[7],
    textDecoration: "none",
    fontWeight: 600,
    "&:hover": { textDecoration: "underline" },
  },
}));

export default function AnnouncementBar() {
  const { classes } = useStyles();

  return (
    <div className={classes.bar} role="region" aria-label="網站公告">
      <PageContainer className={classes.inner}>
        <Text className={classes.text} component="p" m={0}>
          每週空運到港 · 急凍產品預約送貨 ·{" "}
          <Link to="/product" className={classes.link}>
            產品目錄
          </Link>
          {" · "}
          <a href="https://wa.me/85298312915" className={classes.link} target="_blank" rel="noopener noreferrer">
            WhatsApp 9831 2915
          </a>
        </Text>
      </PageContainer>
    </div>
  );
}
